let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("llanw"), load("1sXQt")]).then(() => parcelRequire('lDaLP'));